import { createContext } from 'react';

interface PromptContextProps {
  dismissible: boolean;
  dismissPrompt: () => void;
}

export const PromptContext = createContext<PromptContextProps>({
  dismissible: false,
  dismissPrompt: () => {},
});
